import {
    Field,
    FormikProps
} from 'formik';

import {
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
// import {ManagedAccountsAutocomplete} from "../../managed-accounts/inputs/ManagedAccountsAutocomplete.tsx";
import {
    Container,
    Stack
} from '@mantine/core';
import {Organization} from "../types.ts";


export const FormComponent = (props: FormikProps<Organization>) => {

    const {values} = props;
    const editing = values.id !== undefined;

    return (
        <Container>
            <Stack gap={'xl'}>
                <PlatformFieldset legend={'Organization Details'}>
                    <Field
                        name='name'
                        label='Name'
                        description='Please enter the organization name'
                        component={FormikTextInput}
                        withAsterisk
                        my={'xl'}
                    />

                    <Field
                        name='description'
                        label='Description'
                        description='Please enter organization description'
                        component={FormikTextarea}
                        my={'xl'}
                    />

                </PlatformFieldset>

                {editing ? <PlatformFieldset legend={'Administration'}>
                    <Field
                        name='adminAccountId'
                        label='Admin Account'
                        component={FormikTextInput}
                        withAsterisk
                        my={'xl'}
                    />
                </PlatformFieldset> : null}

                <PlatformFieldset legend={'Contact'}>
                    <Field
                        name='email'
                        label='Email'
                        description='Please enter organization email'
                        component={FormikTextInput}
                        my={'xl'}
                    />
                    <Field
                        name='phone'
                        label='Phone'
                        description='Please enter organization phone number'
                        component={FormikTextInput}
                        my={'xl'}
                    />

                    <Field
                        name='url'
                        label='URL'
                        description='Please enter organization url'
                        component={FormikTextInput}
                        my={'xl'}
                    />

                </PlatformFieldset>

            </Stack>
        </Container>
    );
};
